"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrintableWorksheetsState = exports["default"] = exports.SubjectCodes = exports.PRINTABLE_WORKSHEET_SCREENS = exports.Grades = exports.GradeToStringMapping = void 0;
var _react = _interopRequireWildcard(require("react"));
var _printableWorksheets = require("printableWorksheets");
var _api = require("./api");
var _common = require("apps/teacher/config/common");
var _commonDate = require("apps/teacher/config/commonDate");
var _excluded = ["userId", "worksheetsEnvironment", "onboardingGrade", "children", "subject", "isGradeEligibleForEla"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var WS_FILTERS_LOCAL_STORAGE_KEY = "wsFilterData";
var Grades = exports.Grades = /*#__PURE__*/function (Grades) {
  Grades["ALL_GRADES"] = "All";
  Grades["PRE_K"] = "Pre-K";
  Grades["K"] = "K";
  Grades["ONE"] = "1";
  Grades["TWO"] = "2";
  Grades["THREE"] = "3";
  Grades["FOUR"] = "4";
  Grades["FIVE"] = "5";
  return Grades;
}({});
var SubjectCodes = exports.SubjectCodes = /*#__PURE__*/function (SubjectCodes) {
  SubjectCodes["MATH"] = "math";
  SubjectCodes["ELA"] = "ela";
  return SubjectCodes;
}({});
var PRINTABLE_WORKSHEET_SCREENS = exports.PRINTABLE_WORKSHEET_SCREENS = /*#__PURE__*/function (PRINTABLE_WORKSHEET_SCREENS) {
  PRINTABLE_WORKSHEET_SCREENS[PRINTABLE_WORKSHEET_SCREENS["DEFAULT"] = 0] = "DEFAULT";
  PRINTABLE_WORKSHEET_SCREENS[PRINTABLE_WORKSHEET_SCREENS["SEARCH"] = 1] = "SEARCH";
  PRINTABLE_WORKSHEET_SCREENS[PRINTABLE_WORKSHEET_SCREENS["SAVED"] = 2] = "SAVED";
  PRINTABLE_WORKSHEET_SCREENS[PRINTABLE_WORKSHEET_SCREENS["DOWNLOADED"] = 3] = "DOWNLOADED";
  return PRINTABLE_WORKSHEET_SCREENS;
}({});
var GradeToStringMapping = exports.GradeToStringMapping = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Grades.ALL_GRADES, 'All Grades'), Grades.K, 'Kindergarteners'), Grades.ONE, '1st Graders'), Grades.TWO, '2nd Graders'), Grades.THREE, '3rd Graders'), Grades.FOUR, '4th Graders'), Grades.FIVE, '5th Graders');
;
var PrintableWorksheetsContext = /*#__PURE__*/_react["default"].createContext({});
var PrintableWorksheetsProvider = function PrintableWorksheetsProvider(_ref) {
  var userId = _ref.userId,
    worksheetsEnvironment = _ref.worksheetsEnvironment,
    onboardingGrade = _ref.onboardingGrade,
    children = _ref.children,
    _ref$subject = _ref.subject,
    subject = _ref$subject === void 0 ? SubjectCodes.MATH : _ref$subject,
    isGradeEligibleForEla = _ref.isGradeEligibleForEla,
    envProps = _objectWithoutProperties(_ref, _excluded);
  var mapOnboardingGradeWithGrades = function mapOnboardingGradeWithGrades(grade) {
    var Grade = Object.keys(Grades).find(function (grade) {
      return Grades[grade] === (onboardingGrade === null || onboardingGrade === void 0 ? void 0 : onboardingGrade.toUpperCase());
    });
    return Grade ? Grades[Grade] : Grades.ALL_GRADES;
  };
  var fromOnboardingFlow = (0, _common.hasSignedUpFromWs)() && JSON.parse(localStorage.getItem("showFilteredWsData"));
  var isFromOnboardingFlow = (0, _common.isFlutterUser)() ? window.parent.parent.isFromOnboardingFlow : window.isFromOnboardingFlow;
  var activeGradeAndSubject = (0, _react.useMemo)(function () {
    var gradeToSet = null;
    var subjectToSet = null;
    // @ts-ignore
    if (fromOnboardingFlow || isFromOnboardingFlow) {
      gradeToSet = localStorage.getItem('gradeSelectedOnWs') || 'All';
      subjectToSet = (0, _common.fetchSubjectFromSignupUrl)();
    } else {
      // @ts-ignore
      if (!isFromOnboardingFlow) {
        var _localStorage;
        var filtersFromLocalStorageStr = (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem(WS_FILTERS_LOCAL_STORAGE_KEY);
        var filtersFromLocalStorage = JSON.parse(filtersFromLocalStorageStr || "{}");
        if (Object.keys(filtersFromLocalStorage).length > 0 && filtersFromLocalStorage.userId == userId) {
          gradeToSet = filtersFromLocalStorage.activeGrade;
          subjectToSet = filtersFromLocalStorage.subjectCode;
        } else {
          gradeToSet = mapOnboardingGradeWithGrades(onboardingGrade);
          subjectToSet = subject;
        }
      }
      if (worksheetsEnvironment == _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
        gradeToSet = mapOnboardingGradeWithGrades(onboardingGrade);
        subjectToSet = subject;
      }
    }
    return {
      gradeToSet: gradeToSet,
      subjectToSet: subjectToSet
    };
  }, [fromOnboardingFlow, onboardingGrade, subject]);
  var _useState = (0, _react.useState)(activeGradeAndSubject.gradeToSet),
    _useState2 = _slicedToArray(_useState, 2),
    activeGrade = _useState2[0],
    setActiveGrade = _useState2[1];
  var _useState3 = (0, _react.useState)(activeGradeAndSubject.subjectToSet),
    _useState4 = _slicedToArray(_useState3, 2),
    subjectCode = _useState4[0],
    setSubjectCode = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    activeNode = _useState6[0],
    setActiveNode = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = _slicedToArray(_useState7, 2),
    activeWorksheet = _useState8[0],
    setActiveWorksheet = _useState8[1];
  var _useState9 = (0, _react.useState)(null),
    _useState0 = _slicedToArray(_useState9, 2),
    treeData = _useState0[0],
    setTreeData = _useState0[1];
  var _useState1 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState1, 2),
    ineligibleGrade = _useState10[0],
    setIneligibleGrade = _useState10[1];
  var _useState11 = (0, _react.useState)(null),
    _useState12 = _slicedToArray(_useState11, 2),
    viewData = _useState12[0],
    setViewData = _useState12[1];
  var _useState13 = (0, _react.useState)(''),
    _useState14 = _slicedToArray(_useState13, 2),
    worksheetSearchValue = _useState14[0],
    setWorksheetSearchValue = _useState14[1];
  var _useState15 = (0, _react.useState)([]),
    _useState16 = _slicedToArray(_useState15, 2),
    activeBreadcrumb = _useState16[0],
    setActiveBreadcrumb = _useState16[1];
  var _useState17 = (0, _react.useState)(true),
    _useState18 = _slicedToArray(_useState17, 2),
    showViewHeader = _useState18[0],
    toggleViewHeader = _useState18[1];
  var _useState19 = (0, _react.useState)(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showHeader = _useState20[0],
    setShowHeader = _useState20[1];
  var _useState21 = (0, _react.useState)({}),
    _useState22 = _slicedToArray(_useState21, 2),
    savedWorksheets = _useState22[0],
    setSavedWorksheets = _useState22[1];
  var _useState23 = (0, _react.useState)([]),
    _useState24 = _slicedToArray(_useState23, 2),
    savedEntityWorksheets = _useState24[0],
    setSavedEntityWorksheets = _useState24[1];
  var _useState25 = (0, _react.useState)([]),
    _useState26 = _slicedToArray(_useState25, 2),
    downloadedWorksheets = _useState26[0],
    setDownloadedWorksheets = _useState26[1];
  var _useState27 = (0, _react.useState)(null),
    _useState28 = _slicedToArray(_useState27, 2),
    searchScreenData = _useState28[0],
    setSearchScreenData = _useState28[1];
  var _useState29 = (0, _react.useState)(PRINTABLE_WORKSHEET_SCREENS.DEFAULT),
    _useState30 = _slicedToArray(_useState29, 2),
    activeScreen = _useState30[0],
    setActiveScreen = _useState30[1];
  var _useState31 = (0, _react.useState)(true),
    _useState32 = _slicedToArray(_useState31, 2),
    defaultSearch = _useState32[0],
    setDefaultSearch = _useState32[1];
  var _useState33 = (0, _react.useState)(0),
    _useState34 = _slicedToArray(_useState33, 2),
    savedCount = _useState34[0],
    setSavedCount = _useState34[1];
  var _useState35 = (0, _react.useState)(0),
    _useState36 = _slicedToArray(_useState35, 2),
    downloadCount = _useState36[0],
    setDownloadCount = _useState36[1];
  var _useState37 = (0, _react.useState)(false),
    _useState38 = _slicedToArray(_useState37, 2),
    isWorksheetsLoading = _useState38[0],
    toggleIsWorksheetsLoading = _useState38[1];
  var _useState39 = (0, _react.useState)(''),
    _useState40 = _slicedToArray(_useState39, 2),
    filteredSearchTerm = _useState40[0],
    setFilteredSearchTerm = _useState40[1];
  var _useState41 = (0, _react.useState)({}),
    _useState42 = _slicedToArray(_useState41, 2),
    allWorksheetsScreenData = _useState42[0],
    setAllWorksheetsScreenData = _useState42[1];
  var _useState43 = (0, _react.useState)(false),
    _useState44 = _slicedToArray(_useState43, 2),
    filtersLoadedFromLocalStorage = _useState44[0],
    setFiltersLoadedLoadedFromLocalStorage = _useState44[1];
  var getSortedChildren = function getSortedChildren(children) {
    var res = children.sort(function (a, b) {
      var title1 = a.title.toLowerCase(),
        title2 = b.title.toLowerCase();
      if (title1 < title2) {
        return -1;
      }
      if (title1 > title2) {
        return 1;
      }
      return 0;
    });
    return res;
  };
  var _sortChild = function sortChild(child) {
    var _child$children;
    if ((child === null || child === void 0 || (_child$children = child.children) === null || _child$children === void 0 ? void 0 : _child$children.length) === 0) {
      return child;
    } else {
      child.children = getSortedChildren(child === null || child === void 0 ? void 0 : child.children);
      child.children.map(function (child) {
        return _sortChild(child);
      });
      return child;
    }
  };
  var getAllSearchNodes = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(grade) {
      var isFromOnboardingFlow, paramsMath, paramsELA, promises;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            isFromOnboardingFlow = (0, _common.isFlutterUser)() ? window.parent.parent.isFromOnboardingFlow : window.isFromOnboardingFlow;
            toggleIsWorksheetsLoading(function (curr) {
              return !curr;
            });
            paramsMath = {
              gradeCode: grade,
              subjectCode: SubjectCodes.MATH
            };
            paramsELA = {
              gradeCode: grade,
              subjectCode: SubjectCodes.ELA
            };
            promises = [(0, _api.fetchAllSearchNodes)(paramsMath), (0, _api.fetchAllSearchNodes)(paramsELA)];
            _context.n = 1;
            return Promise.all(promises).then(function (_ref3) {
              var _ref4 = _slicedToArray(_ref3, 2),
                mathRes = _ref4[0],
                elaRes = _ref4[1];
              var sortedMathRes = _sortChild(mathRes);
              var sortedElaRes = _sortChild(elaRes);
              setTreeData([sortedElaRes, sortedMathRes]);
              // setActiveNode(elaRes);
              var initialElement = subject === SubjectCodes.MATH ? sortedMathRes : sortedElaRes;

              // @ts-ignore
              if (fromOnboardingFlow || isFromOnboardingFlow) {
                if ((0, _common.isFlutterUser)()) {
                  window.parent.parent.isFromOnboardingFlow = true;
                } else {
                  window.isFromOnboardingFlow = true;
                }
                var initialData = (0, _common.fetchSubjectFromSignupUrl)() === SubjectCodes.MATH ? sortedMathRes : sortedElaRes;
                var activeBreadcrumbIds = JSON.parse(localStorage.getItem("searchNodeIds"));
                var data = [initialData];
                var activeBreadcrumbData = fetchDataForActiveBreadcrumb(data, activeBreadcrumbIds, initialElement);
                setActiveBreadcrumb(activeBreadcrumbData);
                localStorage.removeItem("showFilteredWsData");
                if ((0, _common.isFlutterUser)()) {
                  window.parent.parent.isFromOnboardingFlow = false;
                } else {
                  window.isFromOnboardingFlow = false;
                }
                persistFilterData(activeBreadcrumbData);
              } else {
                // @ts-ignore
                if (!isFromOnboardingFlow && worksheetsEnvironment == _printableWorksheets.WorksheetsEnvironment.STUDENT_DASHBOARD) {
                  var _localStorage2;
                  var filtersFromLocalStorageStr = (_localStorage2 = localStorage) === null || _localStorage2 === void 0 ? void 0 : _localStorage2.getItem(WS_FILTERS_LOCAL_STORAGE_KEY);
                  var filtersFromLocalStorage = JSON.parse(filtersFromLocalStorageStr || "{}");
                  if (Object.keys(filtersFromLocalStorage).length > 0 && !filtersLoadedFromLocalStorage && filtersFromLocalStorage.userId == userId) {
                    var _filtersFromLocalStor;
                    setActiveBreadcrumb(((_filtersFromLocalStor = filtersFromLocalStorage.activeBreadcrumb) === null || _filtersFromLocalStor === void 0 ? void 0 : _filtersFromLocalStor.length) > 0 ? filtersFromLocalStorage.activeBreadcrumb : [initialElement]);
                  } else {
                    setActiveBreadcrumb([initialElement]);
                  }
                  setFiltersLoadedLoadedFromLocalStorage(true);
                } else {
                  setActiveBreadcrumb([initialElement]);
                }
              }
            })["finally"](function () {
              return toggleIsWorksheetsLoading(function (curr) {
                return !curr;
              });
            });
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function getAllSearchNodes(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var persistFilterData = function persistFilterData() {
    var _activeBreadcrumb$;
    var explicitActiveBreadCrumbData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var dataToStore = {
      userId: userId,
      activeBreadcrumb: explicitActiveBreadCrumbData ? explicitActiveBreadCrumbData : activeBreadcrumb,
      activeGrade: activeGrade,
      subjectCode: (activeBreadcrumb === null || activeBreadcrumb === void 0 || (_activeBreadcrumb$ = activeBreadcrumb[0]) === null || _activeBreadcrumb$ === void 0 ? void 0 : _activeBreadcrumb$.title) == 'ELA' ? SubjectCodes.ELA : SubjectCodes.MATH
    };
    localStorage.setItem(WS_FILTERS_LOCAL_STORAGE_KEY, JSON.stringify(dataToStore));
  };
  (0, _react.useEffect)(function () {
    filtersLoadedFromLocalStorage && persistFilterData();
  }, [activeBreadcrumb, activeGrade, subjectCode]);
  var getNodeContentById = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(nodeIds) {
      var params;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            params = {
              searchNodeIds: nodeIds,
              pageNumber: 0,
              pageSize: 10
            };
            _context2.n = 1;
            return (0, _api.fetchNodesByIds)(params).then(function (res) {
              var dataToSet = [];
              Object.keys(res.search_contents).forEach(function (nodeId) {
                var _activeNode$children;
                var worksheets = res.search_contents[nodeId];
                var match = activeNode === null || activeNode === void 0 || (_activeNode$children = activeNode.children) === null || _activeNode$children === void 0 ? void 0 : _activeNode$children.find(function (node) {
                  return node.id == nodeId;
                });
                var title = match ? match.section_title : "";
                var playblesCount = match ? match.playable_count : 0;
                dataToSet.push({
                  title: title,
                  nodeId: nodeId,
                  worksheets: worksheets,
                  playblesCount: playblesCount
                });
              });
              dataToSet = getSortedChildren(dataToSet);
              setViewData(dataToSet);
            });
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function getNodeContentById(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var getUserSavedCollection = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var pageNumber,
        pageSize,
        _args4 = arguments;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            pageNumber = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : 0;
            pageSize = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 1000;
            if (!userId) {
              _context4.n = 1;
              break;
            }
            _context4.n = 1;
            return (0, _api.fetchSavedWorksheets)({
              userId: userId,
              pageNumber: pageNumber,
              pageSize: pageSize
            }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
              var result,
                data,
                tempSavedWorksheets,
                _args3 = arguments;
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    result = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                    data = result.user_collection_entities || [];
                    tempSavedWorksheets = data.reduce(function (acc, item) {
                      acc[item.entity_id] = item;
                      return acc;
                    }, {});
                    setSavedWorksheets(tempSavedWorksheets);
                  case 1:
                    return _context3.a(2);
                }
              }, _callee3);
            })));
          case 1:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function getUserSavedCollection() {
      return _ref6.apply(this, arguments);
    };
  }();
  var getSavedWorksheets = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var savedWorksheetIds, params, res;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            savedWorksheetIds = Object.keys(savedWorksheets);
            if (!((savedWorksheetIds === null || savedWorksheetIds === void 0 ? void 0 : savedWorksheetIds.length) > 0)) {
              _context5.n = 2;
              break;
            }
            params = {
              ids: savedWorksheetIds
            };
            _context5.n = 1;
            return (0, _api.getWorksheetsByEntityIds)({
              params: params
            });
          case 1:
            res = _context5.v;
            setSavedEntityWorksheets(res);
          case 2:
            return _context5.a(2);
        }
      }, _callee5);
    }));
    return function getSavedWorksheets() {
      return _ref8.apply(this, arguments);
    };
  }();
  var calculateDateFromToday = function calculateDateFromToday(days) {
    return _commonDate.commonDate.CalculateDateFromToday(days);
  };
  var getDownloadedWorksheets = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(selectedDays) {
      var params, downloadedEntities, _params, res, sortedRes;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            params = _objectSpread({
              page_number: 0,
              page_size: 1000,
              created_date_sort: "desc"
            }, selectedDays !== "365" ? {
              created_date_gte: calculateDateFromToday(parseInt(selectedDays) - 1)
            } : {});
            _context6.n = 1;
            return (0, _api.getUserDownloadList)(_objectSpread(_objectSpread({}, params), {}, {
              userId: userId
            }));
          case 1:
            downloadedEntities = _context6.v;
            if (!((downloadedEntities === null || downloadedEntities === void 0 ? void 0 : downloadedEntities.length) > 0)) {
              _context6.n = 3;
              break;
            }
            _params = {
              ids: downloadedEntities === null || downloadedEntities === void 0 ? void 0 : downloadedEntities.map(function (entity) {
                return entity.entity_id;
              })
            };
            _context6.n = 2;
            return (0, _api.getWorksheetsByEntityIds)({
              params: _params
            });
          case 2:
            res = _context6.v;
            sortedRes = [];
            downloadedEntities.forEach(function (entity) {
              res.find(function (worksheet) {
                if ((worksheet === null || worksheet === void 0 ? void 0 : worksheet.id) === entity.entity_id) {
                  sortedRes.push(worksheet);
                }
              });
            });
            setDownloadedWorksheets(sortedRes);
            _context6.n = 4;
            break;
          case 3:
            setDownloadedWorksheets([]);
          case 4:
            return _context6.a(2);
        }
      }, _callee6);
    }));
    return function getDownloadedWorksheets(_x3) {
      return _ref9.apply(this, arguments);
    };
  }();
  var initTeacherWorksheetsData = function initTeacherWorksheetsData() {
    getUserSavedCollection();
    getDownloadedWorksheets("7");
    (0, _api.getUserDownloadsCount)({
      userId: userId
    }).then(function (res) {
      setDownloadCount(res);
    });
    (0, _api.getUserSavedCount)({
      userId: userId
    }).then(function (res) {
      setSavedCount(res);
    });
  };
  var fetchDataForActiveBreadcrumb = function fetchDataForActiveBreadcrumb(data, ids, initialElement) {
    var result = [];
    var idsUpdated = [];
    idsUpdated = ids.length > 0 && ids.reverse();
    var _recursiveFilter = function recursiveFilter(arr) {
      var _iterator = _createForOfIteratorHelper(arr),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (idsUpdated.includes(item.id)) {
            result.push(item);
          }
          if (item.children && item.children.length > 0) {
            _recursiveFilter(item.children);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };
    if (data.length > 0 && idsUpdated.length > 0) {
      _recursiveFilter(data);
    }
    return result.length > 0 ? result : [initialElement];
  };
  (0, _react.useEffect)(function () {
    var _activeNode$children2;
    if (activeNode !== null && activeNode !== void 0 && activeNode.id && (activeNode === null || activeNode === void 0 || (_activeNode$children2 = activeNode.children) === null || _activeNode$children2 === void 0 ? void 0 : _activeNode$children2.length) > 0) {
      getNodeContentById(activeNode === null || activeNode === void 0 ? void 0 : activeNode.children.map(function (node) {
        return node.id;
      }));
    }
  }, [activeNode === null || activeNode === void 0 ? void 0 : activeNode.id]);
  (0, _react.useEffect)(function () {
    if ((activeBreadcrumb === null || activeBreadcrumb === void 0 ? void 0 : activeBreadcrumb.length) > 0) {
      var lastBreadCrumb = activeBreadcrumb[activeBreadcrumb.length - 1];
      setActiveNode(lastBreadCrumb);
    }
  }, [activeBreadcrumb]);
  (0, _react.useEffect)(function () {
    if (activeGrade && subjectCode) {
      setTreeData([]);
      getAllSearchNodes(activeGrade);
    }
  }, [activeGrade, subjectCode]);
  (0, _react.useEffect)(function () {
    // In case ela grade change is required
    if (subject === SubjectCodes.ELA) {
      if (isGradeEligibleForEla && !isGradeEligibleForEla(activeGrade === null || activeGrade === void 0 ? void 0 : activeGrade.toLowerCase())) {
        setIneligibleGrade(true);
      } else {
        setIneligibleGrade(false);
      }
    } else {
      setIneligibleGrade(false);
    }
    if (worksheetsEnvironment == _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
      setSubjectCode(subject);
    }
  }, [subject, activeGrade]);
  (0, _react.useEffect)(function () {
    worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD ? setActiveGrade(onboardingGrade === null || onboardingGrade === void 0 ? void 0 : onboardingGrade.toUpperCase()) : null;
  }, [onboardingGrade]);
  (0, _react.useEffect)(function () {
    worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD ? initTeacherWorksheetsData() : null;
  }, [userId]);
  var PrintableWorksheetsState = {
    activeGrade: activeGrade,
    activeNode: activeNode,
    activeWorksheet: activeWorksheet,
    worksheetSearchValue: worksheetSearchValue,
    subjectCode: subjectCode,
    activeBreadcrumb: activeBreadcrumb,
    showViewHeader: showViewHeader,
    userId: userId,
    worksheetsEnvironment: worksheetsEnvironment,
    treeData: treeData,
    viewData: viewData,
    onboardingGrade: onboardingGrade,
    showHeader: showHeader,
    savedWorksheets: savedWorksheets,
    savedEntityWorksheets: savedEntityWorksheets,
    downloadedWorksheets: downloadedWorksheets,
    searchScreenData: searchScreenData,
    activeScreen: activeScreen,
    defaultSearch: defaultSearch,
    savedCount: savedCount,
    downloadCount: downloadCount,
    isWorksheetsLoading: isWorksheetsLoading,
    envProps: envProps,
    ineligibleGrade: ineligibleGrade,
    filteredSearchTerm: filteredSearchTerm,
    allWorksheetsScreenData: allWorksheetsScreenData,
    setActiveGrade: setActiveGrade,
    setActiveNode: setActiveNode,
    setActiveWorksheet: setActiveWorksheet,
    setWorksheetSearchValue: setWorksheetSearchValue,
    setSubjectCode: setSubjectCode,
    setActiveBreadcrumb: setActiveBreadcrumb,
    toggleViewHeader: toggleViewHeader,
    setShowHeader: setShowHeader,
    setSavedWorksheets: setSavedWorksheets,
    getSavedWorksheets: getSavedWorksheets,
    getDownloadedWorksheets: getDownloadedWorksheets,
    setSearchScreenData: setSearchScreenData,
    setActiveScreen: setActiveScreen,
    setDefaultSearch: setDefaultSearch,
    setSavedCount: setSavedCount,
    setDownloadCount: setDownloadCount,
    setDownloadedWorksheets: setDownloadedWorksheets,
    setSavedEntityWorksheets: setSavedEntityWorksheets,
    setFilteredSearchTerm: setFilteredSearchTerm,
    setAllWorksheetsScreenData: setAllWorksheetsScreenData
  };
  return /*#__PURE__*/_react["default"].createElement(PrintableWorksheetsContext.Provider, {
    value: PrintableWorksheetsState,
    "data-sentry-element": "unknown",
    "data-sentry-component": "PrintableWorksheetsProvider",
    "data-sentry-source-file": "state.tsx"
  }, children);
};
var _usePrintableWorksheetsState = exports.usePrintableWorksheetsState = function usePrintableWorksheetsState() {
  var context = (0, _react.useContext)(PrintableWorksheetsContext);
  if (!context) {
    throw Error("Use ".concat(_usePrintableWorksheetsState.name, " in ").concat(PrintableWorksheetsContext.displayName));
  }
  return context;
};
var _default = exports["default"] = PrintableWorksheetsProvider;